import { Action } from '@ngrx/store';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Follow } from '@app/models/follow';

export enum ShowroomPageActionTypes {
    LoadShowroom = '[API] Load Showroom Cal',
    LoadShowroomSuccess = '[API] Load Showroom Success',
    LoadShowroomFail = '[API] Load Showroom Fail',

    SelectProduct = '[ShowroomPage] Select product',
    SelectProductCountry = '[ShowroomPage] Select product Country',
    SetFilter = '[ShowroomPage] Set Filter',

    UpdateProducts = '[ShowroomPage] Update products',
    UpdateProductsSuccess = '[ShowroomPage] Update products success',
    UpdateProductsFail = '[ShowroomPage] Update products fail',

    UpdateProductCountry = '[ShowroomPage] Update size break',
    UpdateProductCountrySuccess = '[ShowroomPage] Update size break success',
    UpdateProductCountryFail = '[ShowroomPage] Update size break fail'
}

export class LoadShowroom implements Action {
    readonly type = ShowroomPageActionTypes.LoadShowroom;
    constructor(public FollowId: any) {}
}

export class LoadShowroomSuccess implements Action {
    readonly type = ShowroomPageActionTypes.LoadShowroomSuccess;
    constructor(public departments: any[]) {}
}

export class LoadShowroomFail implements Action {
    readonly type = ShowroomPageActionTypes.LoadShowroomFail;
    constructor(public error: any) {}
}

export class SelectProduct implements Action {
    readonly type = ShowroomPageActionTypes.SelectProduct;
    constructor(public id: number) {}
}

export class SelectProductCountry implements Action {
    readonly type = ShowroomPageActionTypes.SelectProductCountry;
    constructor(public id: number) {}
}

export class SetFilter implements Action {
    readonly type = ShowroomPageActionTypes.SetFilter;
    constructor(public filter: string) {}
}

export class UpdateProducts implements Action {
    readonly type = ShowroomPageActionTypes.UpdateProducts;
    constructor(public data: any) {}
}

export class UpdateProductsFail implements Action {
    readonly type = ShowroomPageActionTypes.UpdateProductsFail;
    constructor(public error: any) {}
}

export class UpdateProductsSuccess implements Action {
    readonly type = ShowroomPageActionTypes.UpdateProductsSuccess;
    constructor(public data: any) {}
}

export class UpdateProductCountry implements Action {
    readonly type = ShowroomPageActionTypes.UpdateProductCountry;
    constructor(public data: any) {}
}

export class UpdateProductCountryFail implements Action {
    readonly type = ShowroomPageActionTypes.UpdateProductCountryFail;
    constructor(public error: any) {}
}

export class UpdateProductCountrySuccess implements Action {
    readonly type = ShowroomPageActionTypes.UpdateProductCountrySuccess;
    constructor(public data: any) {}
}

export type ShowroomPageActionsUnion =
    | LoadShowroom
    | LoadShowroomSuccess
    | LoadShowroomFail
    | SetFilter
    | SelectProduct
    | SelectProductCountry
    | UpdateProducts
    | UpdateProductsSuccess
    | UpdateProductsFail
    | UpdateProductCountry
    | UpdateProductCountrySuccess
    | UpdateProductCountryFail;
